// src/data/offeringsData.js
const offeringsData = [
    {
        id: 1,
        title: 'Epic Consulting',
        tags: ['healthcare'],
        summary: 'Over the past decade, I have made a career out of solving complex technical problems and bringing visions to life in the Epic space.',
        icon: '../images/healthcare-it.png',
    },
    {
        id: 11,
        tags: ['integral'],
        title: 'Integral Practice Consulting',
        summary: 'I help individuals, businesses, and communities apply the rich lessons from Integral Theory to their most significant challenges.',
        icon: '../images/integral-practice-consulting.png'
    },
    {
        id: 15,
        tags: ['ai'],
        title: 'AI Consulting',
        summary: 'I use the latest AI tools to develop innovative solutions that tackle complex challenges across various sectors.',
        icon: '../images/ai-consulting.png'
    },
    {
        id: 4,
        tags: ['spiritual'],
        title: 'Spiritual Direction',
        summary: 'I listen to the Spirit with people as one way to deepen their relationship with God, fostering spiritual growth through reflective dialogue and discernment.',
        icon: '../images/spiritual-direction.png'
    },
    {
        id: 8,
        tags: ['spiritual'],
        title: 'Intentional Psychedelic Sessions',
        summary: 'I create and hold sacred space for intentional psychedelic journeys with cannabis, psilocybin, LSD, and others.',
        icon: '../images/entheogenic-facilitation.png',
        story: 'I saw God. That\'s the best language I can come up with to describe my first Ayahuasca journey in 2017. Since then, I\'ve studied and trained to facilitate similar experiences for others with psychedelic substances like ayahuasca, mushrooms, LSD, and even cannabis.'
    },
    {
        id: 5,
        tags: ['spiritual'],
        title: 'Outreach to People at the Margins',
        summary: 'Dedicated to bridging gaps in society, I engage directly with marginalized communities to advocate for and support their needs.',
        icon: '../images/outreach.png'
    },
    {
        id: 6,
        tags: ['spiritual'],
        title: 'Bible Teaching & Preaching',
        summary: 'I bring ancient texts to life by the power of the Holy Spirit with engaging and insightful interpretations that resonate in today\'s world.',
        icon: '../images/bible-teaching.png'
    },
    {
        id: 7,
        tags: ['spiritual'],
        title: 'Prayer Ministry',
        summary: 'I intercede through prayer, seeking Christ\'s miraculous healing and transformative power to manifest in the lives of those I serve.',
        icon: '../images/prayer-ministry.png'
    },
    {
        id: 10,
        tags: ['spiritual'],
        title: 'Ministry of Presence',
        summary: 'I show up and commit to being present with people in the midst of chaos and difficult situations, holding space as a witness.',
        icon: '../images/ministry-of-presence.png'
    },
    {
        id: 9,
        tags: ['spiritual'],
        title: 'Meditation Guidance',
        summary: 'I help people get grounded, transcend the mind, and access new states of being with gentle guided meditations.',
        icon: '../images/meditation-guidance.png'
    },
    {
        id: 13,
        tags: ['spiritual'],
        title: 'Connection Coaching',
        summary: 'I coach individuals on how to create meaningful relationships in both personal and professional settings.',
        icon: '../images/connection-coaching.png'
    },
    {
        id: 14,
        tags: ['integral', 'spiritual'],
        title: 'Authentic Relating Facilitation',
        summary: 'I facilitate sessions where individuals can explore authentic expression and build genuine connections with others.',
        icon: '../images/authentic-relating-facilitation.png'
    },
    {
        id: 2,
        title: 'Project Management',
        tags: ['healthcare', 'web', 'ai'],
        summary: 'I manage cross-functional, high-visibility projects to deliver top results on time and under budget by leveraging data & facilitating difficult conversations.',
        icon: '../images/project-management.png'
    },
    {
        id: 3,
        title: 'Career Mentorship',
        tags: ['healthcare', 'teaching'],
        summary: 'I mentor mid-career professionals looking to grow in expertise, management, and leadership.',
        icon: '../images/career-mentorship.png'
    },
    {
        id: 12,
        title: 'Community Management',
        tags: ['web'],
        summary: 'I foster engaging and vibrant online communities, managing interactions and ensuring a thriving collaborative environment.',
        icon: '../images/community-management.png'
    },
    {
        id: 16,
        title: 'App & Website Creation',
        tags: ['web', 'ai'],
        summary: 'I design and develop custom apps and websites that provide seamless user experiences and drive engagement.',
        icon: '../images/website-design.png'
    },
    {
        id: 17,
        title: 'AI Art & Design',
        tags: ['ai', 'art'],
        summary: 'I create unique, visually captivating AI-generated images that push the boundaries of traditional art and design.',
        icon: '../images/ai-art.png'
    },
    {
        id: 20,
        title: 'Copy Editing',
        tags: ['writing'],
        summary: 'I enhance written content by refining its clarity, coherence, and grammatical precision, ensuring it communicates its intended message effectively.',
        icon: '../images/copy-editing.png'
    },
    {
        id: 18,
        title: 'Translation',
        tags: ['writing'],
        summary: 'I translate texts to and from English, Spanish, Portuguese, and Italian with precision of language and attention to context.',
        icon: '../images/translation.png'
    },
    {
        id: 19,
        title: 'Language Learning',
        tags: ['writing'],
        summary: 'I help people make significant progress with their language learning efforts by focusing on winning strategies at every level.',
        icon: '../images/language-learning.png'
    },
    {
        id: 21,
        title: 'Public Speaking & Storytelling',
        tags: ['writing'],
        summary: 'I craft and deliver engaging speeches and stories that captivate audiences and convey powerful messages.',
        icon: '../images/public-speaking.png'
    },
    {
        id: 22,
        title: 'Vacation Planning',
        tags: ['art'],
        summary: 'I meticulously plan and curate personalized vacations that offer unforgettable experiences tailored to individual preferences.',
        icon: '../images/vacation-planning.png'
    },
    {
        id: 23,
        title: 'Music Curation',
        tags: ['art'],
        summary: 'I create custom playlists that fit specific moods and occasions because I believe music can be a beautiful companion to almost every moment in life.',
        icon: '../images/music-curation.png'
    },
    {
        id: 24,
        title: 'Teaching & Tutoring',
        tags: ['teaching'],
        summary: 'I help dedicated students from 1st grade through college catch up or get ahead on a broad range of subjects with engaging explanations and customized practice.',
        icon: '../images/teaching-and-tutoring.png'
    },
    {
        id: 25,
        title: 'Poetry Writing',
        tags: ['art', 'writing'],
        summary: 'I put words to things for which there is no language--compelled nonetheless.',
        icon: '../images/poetry-writing.png'
    },
    {
        id: 26,
        title: 'Something Else',
        tags: ['art'],
        summary: 'I have many other gifts and talents that just might be what you need! I am always looking for new arrows to add to my quiver.',
        icon: '../images/something-else.png'
    }
];

export default offeringsData;
